module.exports = __webpack_public_path__ + "static/month-default-theme-5a4ea16371af019ba1a1839f74b6fd6d.png";